<template>
  <div>
    <div></div>
    <!-- Assignment Summary Modal Start -->
    <!-- v-if="
        $sessionsStorage.get('designation') == 'Admin' &&
        $sessionsStorage.get('nameUser') == 'Bhavneesh'
      " -->
    <b-button
      v-if="!isIcon"
      style="font-size: 0.675rem ;margin-left:5px"
      @click="AssignmentSummary()"
      size="sm"
      class="mt-1"
      variant="outline-info"
      >Track Shipment</b-button
    >
    <b-button v-else 
        @click="AssignmentSummary()" 
        size="sm" 
        variant="outline-warning" 
        class="mr-1 btn-action"
        v-b-tooltip.hover title="Track Shipment"
    >
        <i :class="iconClass || 'fa fa-truck'"></i>
    </b-button>
    <b-modal
      id="AssignmentSummary-modal"
      ref="AssignmentSummary-modal"
      :title="title + jb_series"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
    
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    
      <!-- <b-row class="mt-3">
        <b-col cols="6"
          ><b>Export</b>
          <br />
          <div class="table-wrapper-scroll-x my-custom-scrollbar">
            <table class="table table-bordered">
              <tbody>
                {{item}}
                <tr v-for="(item, index) in allAssignmentSummaryData" :key="index">
                    <td>Container No.</td>
                    <td>{{ item.Container_No }}</td>
                  </tr>
              </tbody>
            </table>
          </div>
        </b-col>
        <b-col cols="6"><b>Import</b></b-col>
      </b-row> -->
      <div class="row">
        <!-- <div class="col-md-12">Export Details</div> -->
        <div
          class="col-md-12 row table-wrapper-scroll-x my-custom-scrollbar"
          v-if="allAssignmentSummaryData.length > 0"
        >
          <!-- <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].EnquirySeries"
          >
            <b>Enquiry No :</b> {{ allAssignmentSummaryData[0].EnquirySeries }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].ENQ_Date"
          >
            <b>Enquiry Date :</b> {{ allAssignmentSummaryData[0].ENQ_Date }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].quotationSeries"
          >
            <b>Quotation No :</b>
            {{ allAssignmentSummaryData[0].quotationSeries }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].Quot_Date"
          >
            <b>Quotation Date :</b>
            {{ allAssignmentSummaryData[0].Quot_Date }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].Quot_assignSeries"
          >
            <b>Assign No :</b>
            {{ allAssignmentSummaryData[0].Quot_assignSeries }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].Quot_assignDate"
          >
            <b>Assign Date :</b>
            {{ allAssignmentSummaryData[0].Quot_assignDate }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="
              allAssignmentSummaryData[0].isConsolidation ||
              allAssignmentSummaryData[0].isMiscJob
            "
          >
            <b>Assignment Type. :</b>
            <span v-if="allAssignmentSummaryData[0].isConsolidation == 1">{{
              "Consolidation Assignment"
            }}</span>
            <span v-else-if="allAssignmentSummaryData[0].isMiscJob == 1">{{
              "MISCELLANEOUS Assignment"
            }}</span>
            <span v-else>{{ "Normal Assignment" }}</span>
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].Job_Series"
          >
            <b>Assignment No :</b> {{ allAssignmentSummaryData[0].Job_Series }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].JobDate"
          >
            <b>Assignment Date :</b> {{ allAssignmentSummaryData[0].JobDate }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].JobTypes"
          >
            <b>Job Type :</b> {{ allAssignmentSummaryData[0].JobTypes }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].raisedFrom"
          >
            <b>Raised From :</b> {{ allAssignmentSummaryData[0].raisedFrom }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].raisedBy"
          >
            <b>Raised By :</b> {{ allAssignmentSummaryData[0].raisedBy }}
          </div> -->
          <div v-if="allAssignmentSummaryData[0].PICK" class="col-md-4 mt-2 mb-2">
            <b>Pickup :</b> {{ allAssignmentSummaryData[0].PICK }}
          </div>
          <div v-if="allAssignmentSummaryData[0].POL" class="col-md-4 mt-2 mb-2">
            <b>POL :</b> {{ allAssignmentSummaryData[0].POL }}
          </div>
          <div v-if="allAssignmentSummaryData[0].POR" class="col-md-4 mt-2 mb-2">
            <b>POR :</b> {{ allAssignmentSummaryData[0].POR }}
          </div>
          <div v-if="allAssignmentSummaryData[0].POD" class="col-md-4 mt-2 mb-2">
            <b>POD :</b> {{ allAssignmentSummaryData[0].POD }}
          </div>
          <div v-if="allAssignmentSummaryData[0].FPOD" class="col-md-4 mt-2 mb-2">
            <b>FPOD :</b> {{ allAssignmentSummaryData[0].FPOD }}
          </div>
          <div v-if="allAssignmentSummaryData[0].HOV" class="col-md-4 mt-2 mb-2">
            <b>HandOver :</b> {{ allAssignmentSummaryData[0].HOV }}
          </div>
          <div v-if="allAssignmentSummaryData[0].STUF" class="col-md-4 mt-2 mb-2">
            <b>Stuffing :</b> {{ allAssignmentSummaryData[0].STUF }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].overseas_agent"
          >
            <b>Agent :</b> {{ allAssignmentSummaryData[0].overseas_agent }}
          </div>

          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].clientName">
            <b>Client :</b> {{ allAssignmentSummaryData[0].clientName }}
          </div>
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].shippingLine">
            <b>Shipping Line :</b>
            {{ allAssignmentSummaryData[0].shippingLine }}
          </div>
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].FFComodity">
            <b>Commodity :</b>
            {{ allAssignmentSummaryData[0].FFComodity }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].frghtTermsHbl"
          >
            <b>Freight Terms for HBL. :</b>
            {{ allAssignmentSummaryData[0].frghtTermsHbl }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].frghtTermsMbl"
          >
            <b>Freight Terms for MBL. :</b>
            {{ allAssignmentSummaryData[0].frghtTermsMbl }}
          </div>
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].BLType">
            <b>BL Type. :</b>
            {{ allAssignmentSummaryData[0].BLType }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].masterBLNumber"
          >
            <b>MBL NO. :</b>
            {{ allAssignmentSummaryData[0].masterBLNumber }}
          </div>
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].masterBLDate">
            <b>MBL Date. :</b>
            {{ allAssignmentSummaryData[0].masterBLDate }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].houseBLNumber"
          >
            <b>HBL NO. :</b>
            {{ allAssignmentSummaryData[0].houseBLNumber }}
          </div>
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].houseBLDate">
            <b>HBL Date. :</b>
            {{ allAssignmentSummaryData[0].houseBLDate }}
          </div>

          <!-- // Import Start -->
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].preAlertDate">
            <b>Pre-Alert Date. :</b>
            {{ allAssignmentSummaryData[0].preAlertDate }}
          </div>

          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].localIgmNo">
            <b>Local IGM NO. :</b>
            {{ allAssignmentSummaryData[0].localIgmNo }}
          </div>
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].localIgmDate">
            <b>Local IGM Date. :</b>
            {{ allAssignmentSummaryData[0].localIgmDate }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].outOfChargeDate"
          >
            <b>Out of Charge Date. :</b>
            {{ allAssignmentSummaryData[0].outOfChargeDate }}
          </div>

          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].gateIgmNo">
            <b>Gateway IGM No. :</b>
            {{ allAssignmentSummaryData[0].gateIgmNo }}
          </div>
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].gateIgmDate">
            <b>Gateway IGM Date. :</b>
            {{ allAssignmentSummaryData[0].gateIgmDate }}
          </div>
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].arrivalDate">
            <b>Arrival Date. :</b>
            {{ allAssignmentSummaryData[0].arrivalDate }}
          </div>
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].railOutDate">
            <b>RailOut Date. :</b>
            {{ allAssignmentSummaryData[0].railOutDate }}
          </div>

          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].freeDays">
            <b>FreeDays Date. :</b>
            {{ allAssignmentSummaryData[0].freeDays }}
          </div>
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].vesselEta">
            <b>Vessel ETA. :</b>
            {{ allAssignmentSummaryData[0].vesselEta }}
          </div>

          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].vesselFinalDate"
          >
            <b>Vessel Final Date. :</b>
            {{ allAssignmentSummaryData[0].vesselFinalDate }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].surrenderDate"
          >
            <b>Surrender Date. :</b>
            {{ allAssignmentSummaryData[0].surrenderDate }}
          </div>
          <!-- // Import End -->

          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].PrelaertSend">
            <b>Prelaert Status. :</b>
            {{ allAssignmentSummaryData[0].PrelaertSend }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].SubscriptionID"
          >
            <b>Subscription ID. :</b>
            {{ allAssignmentSummaryData[0].SubscriptionID }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].sub_noti_risk_verbose"
          >
            <b v-if="allAssignmentSummaryData[0].sub_noti_risk_verbose"
              >Subscription Status:</b
            >{{ allAssignmentSummaryData[0].sub_noti_risk_verbose }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].sub_noti_risk_description"
          >
            <b v-if="allAssignmentSummaryData[0].sub_noti_risk_description"
              >Subscription Description:</b
            >{{ allAssignmentSummaryData[0].sub_noti_risk_description }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].sub_noti_conclusion"
          >
            <b v-if="allAssignmentSummaryData[0].sub_noti_conclusion"
              >Subscription Conclusion:</b
            >{{ allAssignmentSummaryData[0].sub_noti_conclusion }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].subscription_status_detials"
          >
            <b v-if="allAssignmentSummaryData[0].subscription_status_detials"
              >Subscription Create Status:</b
            >{{ allAssignmentSummaryData[0].subscription_status_detials }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].sob_date_detected"
          >
            <b>SOB Date :</b>
            {{ allAssignmentSummaryData[0].sob_date_detected }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].Subscription_CreateDate"
          >
            <b>Subscription Created :</b>
            {{ allAssignmentSummaryData[0].Subscription_CreateDate }}
          </div>
          <!-- <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].subscription_status_detials"
          >
            <b>Subscription Status :</b>
            {{ allAssignmentSummaryData[0].subscription_status_detials }}
          </div> -->
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].vessel_voyage"
          >
            <b>Vessel/voyage :</b>
            {{ allAssignmentSummaryData[0].vessel_voyage }}
          </div>

          <!-- <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].sob_date_detected"
          >
            <b>SOB Date Detected. :</b>
            {{ allAssignmentSummaryData[0].sob_date_detected }}
          </div> -->
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].ETA_destination_estimated"
          >
            <b>ETA Destination Estimated. :</b>
            {{ allAssignmentSummaryData[0].ETA_destination_estimated }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].ETA_destination_actual"
          >
            <b>ETA Destination Actual. :</b>
            {{ allAssignmentSummaryData[0].ETA_destination_actual }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].ETA_loadport_initial"
          >
            <b>ETA Loadport Initial :</b>
            {{ allAssignmentSummaryData[0].ETA_loadport_initial }}
          </div>
          <div
            v-if="allAssignmentSummaryData[0].Eta_loadport_actual"
            class="col-md-4 mt-2 mb-2"
          >
            <b>ETA Loadport Actual :</b>
            {{ allAssignmentSummaryData[0].Eta_loadport_actual }}
          </div>
          <div
            v-if="allAssignmentSummaryData[0].validBookingNo"
            class="col-md-4 mt-2 mb-2"
          >
            <b>Booking No :</b>
            {{ allAssignmentSummaryData[0].validBookingNo }}
          </div>
          <!-- <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].estimatedDate"
          >
            <b>Estimated Date. :</b>
            {{ allAssignmentSummaryData[0].estimatedDate }}
          </div> -->
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].type">
            <b>Transport Type. :</b>
            {{ allAssignmentSummaryData[0].type }}
          </div>
          <!-- <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].clientType"
          >
            <b>Client Type :</b>
            {{
              allAssignmentSummaryData[0].clientType == 1 ? "Client" : "Lead"
            }}
          </div> -->
          <!-- <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].portType"
          >
            <b>Port Type. :</b>
            {{ allAssignmentSummaryData[0].portType }}
          </div> -->
          <!-- <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].transportType"
          >
            <b>IMP/EXP. :</b>
            {{ allAssignmentSummaryData[0].transportType }}
          </div> -->
          <!-- <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].containerInfo"
          >
            <b>Container Info. :</b>
            {{ allAssignmentSummaryData[0].containerInfo.toUpperCase() }}
          </div> -->

          <!-- <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].shipmentType"
          >
            <b>Shipment Type. :</b>
            {{ allAssignmentSummaryData[0].shipmentType == 1 ? "SEA" : "AIR" }}
          </div> -->
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].stuffingType">
            <b v-if="allAssignmentSummaryData[0].transportType == 'Import'"
              >De-Stuffing Type. :</b
            >
            <b v-if="allAssignmentSummaryData[0].transportType == 'Export'"
              >Stuffing Type. :</b
            >
            {{ allAssignmentSummaryData[0].stuffingType.toUpperCase() }}
          </div>
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].deliveryMode">
            <b>Delivery Mode. :</b>
            {{ allAssignmentSummaryData[0].deliveryMode.toUpperCase() }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].deliveryTerms"
          >
            <b>Delivery Terms. :</b>
            {{ allAssignmentSummaryData[0].deliveryTerms.toUpperCase() }}
          </div>
          <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].multipleContainerType"
          >
            <b>Multi. Cont. Type. :</b>
            {{ allAssignmentSummaryData[0].multipleContainerType }}
          </div>
          <!-- <div
            class="col-md-4 mt-2 mb-2"
            v-if="allAssignmentSummaryData[0].Booking_No"
          >
            <b>Booking No. :</b>
            {{ allAssignmentSummaryData[0].Booking_No }}
          </div> -->
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].CreditNoteNo">
            <b>Credit Note. :</b>
            {{ allAssignmentSummaryData[0].CreditNoteNo }}
          </div>
          <div class="col-md-4 mt-2 mb-2" v-if="allAssignmentSummaryData[0].DebitNoteNo">
            <b>Debit Note. :</b>
            {{ allAssignmentSummaryData[0].DebitNoteNo }}
          </div>
          <div class="col-md-12 mt-2 mb-2">
            <Profit-Loss
              v-if="fk_all_module_id"
              :PMS_fk_all_module_id="fk_all_module_id"
              :PMS_jb_series="jb_series"
              :PMS_fk_client_id="allAssignmentSummaryData[0].clientName"
              :PLAccordianStatus="false"
              :PLAccordianButton="true"
            />
          </div>
          <div
            class="col-md-12 table-wrapper-scroll-y my-custom-scrollbar_xAxis"
            v-if="ContainerDetails.length > 0"
          >
            <table class="table mb-0 table-bordered">
              <tr v-for="(con_item, con_index) in ContainerDetails" :key="con_index">
                <th v-if="con_item.GRcontainerNo || con_item.containerNo">
                  <b
                    v-if="
                      con_item.GRcontainerNo != null &&
                      con_item.GRcontainerNo != undefined &&
                      con_item.GRcontainerNo != ''
                    "
                    >{{ "Container No : " + con_item.GRcontainerNo }}</b
                  >
                  <b v-else>{{ "Container No : " + con_item.containerNo }}</b>
                </th>
                <th v-if="con_item.containerType">
                  {{ "Container Type : " + con_item.containerType }}
                </th>
                <!-- <th v-if="con_item.TEUS_Type">
                  {{ "TEUS : " + con_item.TEUS_Type }}
                </th> -->

                <th v-if="con_item.shipperInvoiceNo || con_item.shipperInvoiceDate">
                  {{ "Ship INV No. : " + con_item.shipperInvoiceNo }}<br />
                  {{ "Ship INV Date : " + con_item.shipperInvoiceDate }}
                </th>
                <!-- <th v-if="con_item.shipperInvoiceDate">
                  {{ "Ship INV Date : " + con_item.shipperInvoiceDate }}
                </th> -->
                <th v-if="con_item.shippingBillNo || con_item.shippingBillDate">
                  <b v-if="con_item.shippingBillNo"
                    >{{ "Shipping Bill No : " + con_item.shippingBillNo }}<br
                  /></b>
                  <b v-if="con_item.shippingBillDate">{{
                    "Shipping Bill Date : " + con_item.shippingBillDate
                  }}</b>
                </th>
                <th v-if="con_item.containerBookingNo">
                  <b v-if="con_item.containerBookingNo">{{
                    "Cont. BKG No. : " + con_item.containerBookingNo
                  }}</b>
                </th>
                <th
                  v-if="
                    con_item.ContPICK ||
                    con_item.ContSTUF ||
                    con_item.PickupDate ||
                    con_item.HandoverDate
                  "
                >
                  <b v-if="con_item.ContPICK">{{ "Pickup. : " + con_item.ContPICK }}</b>
                  <b v-if="con_item.ContSTUF">{{ "Stuffing. : " + con_item.ContSTUF }}</b>
                  <b v-if="con_item.PickupDate">{{
                    "Pickup Date. : " + con_item.PickupDate
                  }}</b>
                  <b v-if="con_item.HandoverDate">{{
                    "Handover Date. : " + con_item.HandoverDate
                  }}</b>
                </th>
                <th
                  v-if="
                    con_item.customSealNo || con_item.LineSealNo || con_item.slineSealNo
                  "
                >
                  <b v-if="con_item.customSealNo"
                    >{{ "Custom Seal No. : " + con_item.customSealNo }}<br
                  /></b>
                  <b v-if="con_item.LineSealNo"
                    >{{ "Line Seal No. : " + con_item.LineSealNo }}<br
                  /></b>
                  <b v-if="con_item.slineSealNo">{{
                    "Sline SealNo. : " + con_item.slineSealNo
                  }}</b>
                </th>
                <!-- <th v-if="con_item.LineSealNo">
                  {{ "Line Seal No. : " + con_item.LineSealNo }}
                </th> -->
                <!-- <th v-if="con_item.tptGrnId != 0">
                  {{ "GRN No. : " + "GRN/" + con_item.tptGrnId }}
                </th> -->
                <th v-if="con_item.GRNSeries || con_item.vehicleNo || con_item.GRNDate">
                  {{ "GRN No. : " + con_item.GRNSeries }}<br />
                  {{ "GRN Date. : " + con_item.GRNDate }}<br />
                  {{ "Vehicle No. : " + con_item.vehicleNo }}<br />
                </th>
                <!-- <th v-if="con_item.FuelSlipNo">
                  {{ "Fuel Slip No. : " + con_item.FuelSlipNo }}
                </th> -->
                <!-- <th v-if="con_item.vehicleNo">
                  {{ "Vehicle No. : " + con_item.vehicleNo }}
                </th> -->
                <!-- <th v-if="con_item.refuelAddress">
                  {{ "Refuel Address. : " + con_item.refuelAddress }}
                </th>
                <th v-if="con_item.tollInCash">
                  {{ "Toll In Cash. : " + con_item.tollInCash }}
                </th>
                <th v-if="con_item.otherCashExpenses">
                  {{ "Other Cash Expenses. : " + con_item.otherCashExpenses }}
                </th>
                <th v-if="con_item.diesel">
                  {{ "Diesel. : " + con_item.diesel }}
                </th>
                <th v-if="con_item.dieselPrice">
                  {{ "Diesel Price. : " + con_item.dieselPrice }}
                </th>
                <th v-if="con_item.cashDeiselPaid">
                  {{ "Cash Deisel Paid. : " + con_item.cashDeiselPaid }}
                </th>
                <th v-if="con_item.totalCost">
                  {{ "Total Cost. : " + con_item.totalCost }}
                </th> -->
                <!-- <th v-if="con_item.slineSealNo">
                  {{ "Sline SealNo. : " + con_item.slineSealNo }}
                </th> -->
                <!-- <th v-if="con_item.movementType">
                  {{ "Movement Type. : " + con_item.movementType }}
                </th> -->
                <th v-if="con_item.invoiceNo">
                  {{ "INV No. : " + con_item.invoiceNo }}
                </th>
                <th v-if="con_item.measurement">
                  {{ "Measurement. : " + con_item.measurement }}
                </th>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <b-button @click="hideAssignmentSummary" variant="danger" class="pull-right">
        Close</b-button
      >
    </b-modal>
    <!-- Assignment Summary Modal End -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import ProfitLoss from "../common/profitLoss.vue";
export default {
  props: [
    "title",
    "assign_date",
    "assign_job_type",
    "assign_raised_from",
    "assign_raised_by",
    "fk_all_module_id",
    "jb_series",
    "fk_client_id",
    "fk_pod_id",
    "isIcon",
    "iconClass"
  ],
  beforeMount() {
    if (this.fk_all_module_id != "" && this.Filter_Flag == true) {
      this.getAssignmentSummary();
    }
  },

  data() {
    return {
      isLoading:false,
      allAssignmentSummaryData: [],
      all_module_id: this.fk_all_module_id,
      Filter_Flag: false,
      ContainerDetails: [],
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    ProfitLoss,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    AssignmentSummary() {
      this.Filter_Flag = true;
      // alert(this.Filter_Flag);
      this.$refs["AssignmentSummary-modal"].show();
      this.getAssignmentSummary();
    },
    hideAssignmentSummary() {
      this.Filter_Flag = false;
      this.$refs["AssignmentSummary-modal"].hide();
    },
    getAssignmentSummary() {
      if (this.Filter_Flag == true) {
        
      this.isLoading = true;
        let AssignmentSummary = {
          filter: "AssignmentSummary",
          allModuleId: this.fk_all_module_id,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/viewAssignmentTrackDetails.php`,
          data: JSON.stringify(AssignmentSummary),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              
             this.isLoading = false;
              if (data.AssignmentSummaryData.length > 0) {
                this.allAssignmentSummaryData = data.AssignmentSummaryData;
                this.ContainerDetails = data.AssignmentSummaryData[0].Container_Det;
              }
              // this.isLoading = false;
              this.JqueryFun();
            }
          })
          .catch((error) => {});
      }
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// assignmentSummary.vue?32ccf51c